import {Component, ViewEncapsulation} from '@angular/core';
import {AngularFireDatabase} from '@angular/fire/database';
import {AngularFireAuth} from '@angular/fire/auth';
import {CurrentUserComponent} from './current-user/current-user.component';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
  encapsulation : ViewEncapsulation.Emulated
})
export class AppComponent {
  title = 'art-promenade';

  auth: AngularFireAuth;

  constructor(db: AngularFireDatabase, curUser: CurrentUserComponent) {
    this.auth = curUser.auth;
  }

}
